import { personOf } from '../lib/types'
import type { Assignee } from '../lib/types'

const SIZES = {
  sm: 'size-6',
  md: 'size-8',
  lg: 'size-10',
} as const

type Props = {
  id: Assignee
  size?: keyof typeof SIZES
  className?: string
}

export function Avatar({ id, size = 'sm', className = '' }: Props) {
  const person = personOf(id)
  return (
    <img
      src={person.avatar}
      alt={person.name}
      title={person.name}
      loading="lazy"
      className={`${SIZES[size]} shrink-0 rounded-full object-cover ring-1 ring-black/5 ${className}`}
    />
  )
}
